<template>
    <el-menu
      router
      :default-active=this.activeName
      mode="horizontal"
      background-color='rgb(219,124,2)'
      text-color=antiquewhite
      active-text-color=antiquewhite
      style="width:100%;
          display: flex;" 
    >
    <a href="" style="font-size:40px; width:30%;margin:auto;display:flex; align-items:center; height:100%; ">
      <el-image :src="require('../assets/logo.png')" style="height:50px;"/>      
    </a>
    <span style="width:10%"></span>
      <el-menu-item index="/">Home</el-menu-item>
      <el-submenu index="/browse">
        <template slot="title">Browse</template>
        <el-menu-item class="sub-title" index="/browse/MDD" name="MDD">Major depressive disorder</el-menu-item>
        <el-menu-item class="sub-title" index="/browse/BD">Bipolar disorder</el-menu-item>
        <el-menu-item class="sub-title" index="/browse/SZ">Schizophrenia</el-menu-item>
        <el-menu-item class="sub-title" index="/browse/AX">Anxiety disorder</el-menu-item>
      </el-submenu>

      <el-submenu index="/search">
        <template slot="title">Search</template>
        <el-menu-item class="sub-title" index="/search/snp" name="snp">SNP</el-menu-item>
        <el-menu-item class="sub-title" index="/search/gene" name="gene">Gene</el-menu-item>
        <el-menu-item class="sub-title" index="/search/rna" name="rna">ncRNA</el-menu-item>
        <el-menu-item class="sub-title" index="/search/methylation" name="methylation">Methylation</el-menu-item>
        <el-menu-item class="sub-title" index="/search/metabolite" name="metabolite">Metabolite</el-menu-item>
        <el-menu-item class="sub-title" index="/search/protein" name="protein">Protein</el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="/prediction">
        <template slot="title">Prediction</template>
        <el-menu-item class="sub-title" index="/prediction/results" name="result">Results</el-menu-item>
        <el-menu-item class="sub-title" index="/prediction/tool" name="tool">Online tool</el-menu-item>
      </el-submenu> -->

      <el-submenu index="/analysis">
        <template slot="title">Analysis</template>
        <el-submenu class="sub-title" index="/analysis/differential">
          <template slot="title" style="line-height:72px;!important height:72px !important">Differential analysis</template>
          <el-menu-item class="sub-title" index="/analysis/differential/expression">Gene expression</el-menu-item>
          <el-menu-item class="sub-title" index="/analysis/differential/methylation">DNA methylation</el-menu-item>
        </el-submenu>
        <el-submenu class="sub-title" style="line-height:72px !important" index="/analysis/enrichment">
          <template slot="title" style="line-height:72px;height:72px">Enrichment analysis</template>
          <el-menu-item class="sub-title" index="/analysis/enrichment/conventional">Conventional method</el-menu-item>
          <el-menu-item class="sub-title" index="/analysis/enrichment/weat_gtxblood">WEAT:GTX blood expression</el-menu-item>
          <el-menu-item class="sub-title" index="/analysis/enrichment/weat_gtxbrain">WEAT:GTX brain expression</el-menu-item>
          <el-menu-item class="sub-title" index="/analysis/enrichment/weat_disgenet">WEAT:DisGeNET score</el-menu-item>
      </el-submenu>
        <el-menu-item class="sub-title" index="/analysis/prediction">Prediction</el-menu-item>
      </el-submenu>

      <el-submenu index="/visualization">
        <template slot="title">Visualization</template>
        
        <el-menu-item class="sub-title" index="/visualization/ppi" name="ppi">PPI</el-menu-item>
        <el-menu-item class="sub-title" index="/visualization/relation" name="relation">Relation</el-menu-item>
        <el-menu-item class="sub-title" index="/visualization/location" name="location">Location</el-menu-item>
        <!-- <el-menu-item class="sub-title" index="/visualization/expression" name="expression">Expression</el-menu-item> -->
      </el-submenu>

      <el-menu-item index="/download">Download</el-menu-item>
      <el-menu-item index="/tutorials">Tutorials</el-menu-item>
      <el-menu-item index="/about" >About</el-menu-item>
    </el-menu>
</template>

<script>

export default{
  data(){
    return{
      activeName:this.$route.path
    }
   },
  watch:{
    $route:{
      immediate:true, //url不发生变化，也可以执行的
      handler(newVal,oldVal){
          this.activeName=this.$route.path
      }
    }
  }
}

</script>


<style scoped>
/*menu*/
/deep/.el-menu-item {
    font-size:20px ;
    text-align: center;
  } 
  /deep/.el-menu-item:hover {
    background:  rgb(185, 88, 3) !important;
  }
/*submenu*/
  /deep/.el-submenu__title {
    font-size:20px ;
    text-align: center;

  } 
  /deep/.el-submenu__title:hover {
    background:  rgb(185, 88, 3) !important;
  }
 /*horizontal menu*/
  .el-menu--horizontal .el-menu .el-menu-item{
    font-size:20px ;
    text-align: center;
    height:100% ;

    width: 300px !important;

  }
  .el-menu--horizontal .el-menu .el-menu-item:hover{
    background:  rgb(185, 88, 3) !important;
  }
 /*icon*/
 /deep/.el-submenu__icon-arrow{
  color:antiquewhite;
 }
</style>
